// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__14ojX","notes":"Notes_notes__nL4R2","note":"Notes_note__1oAX0","markdown":"Notes_markdown__m4DA6"};